module.exports = __webpack_public_path__ + "static/media/icon32.54282b66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon32.svg
// module id = 509
// module chunks = 0